/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATION } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAdminPresentationListsMethods extends IPluginMethodMap {
  getAdminPresentationListsProps(args: any): Promise<any>;
}

export class AdminPresentationListsService implements IAgentPlugin {
  readonly methods: IAdminPresentationListsMethods;

  constructor() {
    this.methods = {
      getAdminPresentationListsProps:
        this.getAdminPresentationListsProps.bind(this),
    };
  }

  async getAdminPresentationListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATION,
          variables: {
            filter: {
              // year: {
              //   eq: "2024",
              // },
              status: {
                eq: "active",
              },
            },
            options: {
              limit: 0,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        return {
          presentationLists: this.addProperties(
            this.transformData(res?.data?.getPresentations?.content)
          ),
        };
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private transformData(inputData: any): any[] {
    if (!inputData || inputData.length === 0) {
      return [];
    }

    return inputData.map((item: any) => {
      return {
        id: item?.id,
        name: item?.name,
        status: item?.status || "active",
        sections:
          item?.sections?.map((section: any) => {
            return {
              id: section?.id,
              name: section?.name,
              costumeTypes: section?.costumeTypes || [],
            };
          }) || [],
      };
    });
  }
  addProperties(inputData: any[]): any[] {
    console.log("output---> input", inputData);
    if (!inputData || inputData.length === 0) {
      return [];
    }
    const partitionOption: { id: string; label: string }[] = [
      { id: "Default", label: "Default" },
      { id: "SectionSpecific", label: "SectionSpecific" },
      { id: "SpecialReserve", label: "SpecialReserve" },
    ];

    return inputData.map((obj) => {
      const sections = obj.sections;
      const defaultSectionOptType: { id: string; label: string }[] = [];
      const specialReserveSectionOptType: { id: string; label: string }[] = [];

      sections.forEach((section: any) => {
        section.costumeTypes.forEach((costumeType: any) => {
          const { id, name } = costumeType;
          const option = { id: name, label: name };

          if (!defaultSectionOptType.some((opt) => opt.id === option.id)) {
            defaultSectionOptType.push(option);
          }

          if (
            !specialReserveSectionOptType.some((opt) => opt.id === option.id)
          ) {
            specialReserveSectionOptType.push(option);
          }
        });
      });

      return {
        ...obj,
        defaultSectionOptType,
        specialReserveSectionOptType,
        partitionOption,
        sectionsAndSectionOptType: sections.map((section: any) => {
          const sectionSpecificSectionOptType: { id: string; label: string }[] =
            [];
          section.costumeTypes.forEach((costumeType: any) => {
            const { id, name } = costumeType;
            const option = { id: name, label: name };

            if (
              !sectionSpecificSectionOptType.some((opt) => opt.id === option.id)
            ) {
              sectionSpecificSectionOptType.push(option);
            }

            if (
              !specialReserveSectionOptType.some((opt) => opt.id === option.id)
            ) {
              specialReserveSectionOptType.push(option);
            }
          });

          return {
            id: section.id,
            name: section.name,
            sectionSpecificSectionOptType,
          };
        }),
      };
    });
  }
}
